import { useEffect, useRef, useState } from "react";
import { Paper } from "@mui/material";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CellValueChangedEvent, GridReadyEvent } from "ag-grid-community";
import { useCallback } from "react";
import { api } from "../../../../utils/api";
import { ClaimTransaction } from "../../../../types/claimList.types";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";
import { Button } from "@mui/material";
import { Avatar } from "@mui/material";
import { useContext } from "react";
import { AuthContext, DependentContext, PaycheckContext } from "../../../../contexts";
import { Suspense } from "react";
import ProfileSubHeader from "../../profile/profileSubHeader/ProfileSubHeader";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import Pagination from "@mui/material/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";
import CustomFloatingFilter from "./../../../shared/customFloatingFilter/CustomFloatingFilter";
import CustomFilter from "./../../../shared/customFilter/CustomFilter";
import getLimit from "../../../../utils/pagination/getLimit";

import "./claimList.css";
import { ClaimListQuery } from "../../../../utils/api/claim/claimList";
import { Member } from "../../../../types/employee.types";
import { trackPromise } from "react-promise-tracker";
import { GROUP_NUMBER } from "../../../../constants/groupNumber/groupNumber";

type PDDT = {
	value: string;
};

type CheckNumber = {
	value: number | null;
};

type EOBClickProps = {
	_: unknown;
	_currentClaims: ClaimTransaction[];
	_historyClaims: ClaimTransaction[];
	_dependent: Member;
};

const ClaimList = (): JSX.Element => {
	const { dependent } = useContext(DependentContext);
	const history = useHistory();
	const [currentClaims, setCurrentClaims] = useState<ClaimTransaction[]>([]);
	const [currentClaims1, setCurrentClaims1] = useState([]);
	const [currentClaims2, setCurrentClaims2] = useState([]);
	const location = useLocation();
	const [historyClaims, setHistoryClaims] = useState<ClaimTransaction[]>([]);
	const [claimsFilterSchema, setClaimsFilterSchema] = useState({
		CLMPRE: { value: null, type: null },
		CLMNO: { value: null, type: null },
		CLMSUF: { value: null, type: null },
		PDDT: { value: null, type: null },
		PRVCKNO: { value: null, type: null },
		EECKNO: { value: null, type: null }
	});
	const [avatarInitials, setAvatarInitials] = useState<string>("");
	const { paycheck } = useContext(PaycheckContext);
	const { member } = useContext(AuthContext);
	const [limit, setLimit] = useState<any | null>(null);
	const [pagination, setPagination] = useState({
		currentPage: 1,
		pageCount: 11
	});
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const agGridRef = useRef<any>(null);

	const handleAgGridReady = (params: GridReadyEvent) => {
		params.api.sizeColumnsToFit();
	};

	const xl = useMediaQuery("(min-width:1600px)");
	const lg = useMediaQuery("(min-width:1200px)");
	const md = useMediaQuery("(min-width:800px)");
	const sm = useMediaQuery("(min-width:600px)");
	const xs = useMediaQuery("(min-width:400px)");
	const _limit = getLimit(xl, lg, md, sm, xs);

	const handlePageChange = useCallback(
		(_, value) => {
			// console.log("page_value", value);
			setPagination(
				Object.assign({}, pagination, {
					currentPage: value
				})
			);
			// console.log("limit", limit);
		},
		[limit, pagination]
	);

	// const getPageCount = useCallback(async () => {
	// 	if (limit) {
	// 		const userCount = 15;
	// 		const _pageCount = Math.ceil(userCount / limit);
	// 		setPagination(
	// 			Object.assign({}, pagination, {
	// 				pageCount: _pageCount
	// 			})
	// 		);
	// 	}
	// }, [limit, pagination]);

	const { currentPage, pageCount } = pagination;

	const getClaimList = useCallback(async (): Promise<void> => {
		if (
			member === null ||
			member === undefined ||
			member?.dependent_number === null ||
			member.employee_number === null ||
			member.employee_number === undefined
		) {
			return;
		}
		const loggedInRole = localStorage.getItem("@role");
		const pathname = location.pathname;
		let dependentNumber: number | undefined = undefined;

		if (pathname === "/dependent") {
			//const { dependent } = location.state as { dependent: Member };
			if (dependent && dependent.dependent_number) {
				dependentNumber = dependent.dependent_number;
			}
		} else {
			dependentNumber = member.dependent_number;
		}
		if (dependentNumber === undefined) {
			return;
		}
		// console.log("member", member);
		const claimListQuery: ClaimListQuery = {
			dependent_number: dependentNumber
		};
		const claims = await trackPromise(api.claim.getClaimList(claimListQuery));
		if (claims) {
			setCurrentClaims(Object.assign([], claims.currentClaims));
			setHistoryClaims(Object.assign([], claims.historyClaims));
		}
	}, [dependent, location.pathname, member]);

	const PDDTCellRenderer = ({ value }: PDDT) => {
		return <>{dateTimeZoneConverter(value)}</>;
	};

	const checkIfClaimExists = (claims: ClaimTransaction[], claim: ClaimTransaction): boolean => {
		let claimExists = false;
		for (let eachClaimIdx = 0; eachClaimIdx < claims.length; eachClaimIdx++) {
			const { CLMPRE, CLMNO, CLMSUF } = claims[eachClaimIdx];
			// console.log("clmno", CLMNO, claim.CLMNO);
			if (CLMPRE === claim.CLMPRE && CLMNO === claim.CLMNO && CLMSUF === claim.CLMSUF) {
				claimExists = true;
				break;
			}
		}
		return claimExists;
	};

	const handleEOBClick = useCallback(
		(_currentClaims, _historyClaims, _dependent) => {
			if (agGridRef?.current) {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				const focusedCell = agGridRef.current!.api!.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
				const { data } = row;
				const { CLMNO, CLMSUF, CLMPRE } = data;
				let type = -1;
				if (checkIfClaimExists(_currentClaims, data)) {
					type = 0;
				} else if (checkIfClaimExists(_historyClaims, data)) {
					type = 1;
				}
				const pathname = location.pathname;
				if (pathname === "/dependent") {
					if (_dependent && _dependent.dependent_number) {
						// console.log("_dpe", _dependent);
						history.push(
							`/dependent/claim/EOB?type=${type}&&number=${CLMNO}&&suffix=${CLMSUF}&&pre=${CLMPRE}&&dn=${btoa(
								_dependent.dependent_number
							)}`
						);
						// history.push({
						// 	pathname: `/dependent/claim/EOB?type=${type}&&number=${CLMNO}&&suffix=${CLMSUF}&&pre=${CLMPRE}`,
						// 	state: {
						// 		dependent: {
						// 			dependent_number: _dependent.dependent_number
						// 		}
						// 	}
						// });
					}
				} else {
					history.push(`/claim/EOB?type=${type}&&number=${CLMNO}&&suffix=${CLMSUF}&&pre=${CLMPRE}`);
				}
			}
		},
		[history, location.pathname]
	);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const actionCellRender = ({ _, _currentClaims, _historyClaims, _dependent }: EOBClickProps) => {
		//// console.log("_currentClaims", _currentClaims);
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={() => handleEOBClick(_currentClaims, _historyClaims, _dependent)}
			>
				EOB
			</Button>
		);
	};

	const checkNumberCellRender = ({ value }: CheckNumber) => {
		return <>{value ? value : "N/A"}</>;
	};

	const functionToBePassed = () => {
		// console.log("I am functionToBePassed");
	};

	const getAvatarInitials = useCallback(() => {
		const pathname = location.pathname;
		if (pathname === "/dependent") {
			//const { dependent } = location.state as { dependent: Member };
			if (dependent) {
				setAvatarInitials(dependent.first_name[0] + dependent.last_name[0]);
			}
		} else {
			if (member?.group_number && member?.first_name && member?.last_name) {
				setAvatarInitials(member.first_name[0] + member.last_name[0]);
			}
		}
	}, [dependent, location.pathname, member?.first_name, member?.group_number, member?.last_name]);

	useEffect(() => {
		getClaimList();
		getAvatarInitials();
	}, [getAvatarInitials, getClaimList]);

	if (!member || (location.pathname === "/dependent" && dependent === null)) {
		return <></>;
	}

	return (
		<div className="claim-list theme-container">
			{member.group_number === GROUP_NUMBER.Brookshire_Brothers ? (
				<Helmet>
					<title>Brookshire Brothers - Claim List</title>
				</Helmet>
			) : member.group_number === GROUP_NUMBER.Intercity_Investment ? (
				<Helmet>
					<title>Intercity Investments - Claim List</title>
				</Helmet>
			) : (
				<Helmet>
					<title>Nexcal Member Portal</title>
				</Helmet>
			)}
			<Paper className="theme-border-radius paper-container">
				<div className="theme-profile-header">
					<div className="theme-name">
						{dependent
							? dependent?.first_name + " " + dependent?.last_name
							: member?.first_name + " " + member?.last_name}
					</div>
					<div className="theme-avatar-meta-cont">
						<Avatar className="theme-avatar">{avatarInitials}</Avatar>
						<div className="theme-assign-info">
							<div className="theme-group-name">{member?.group?.name}</div>
							<div className="theme-location-name">{paycheck?.location_name}</div>
						</div>
					</div>
				</div>
				<Suspense fallback={<div />}>
					<ProfileSubHeader title={"Claims"} actionButtons={[]} style={{ marginBottom: 0 }} />
				</Suspense>
				<div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={[...currentClaims, ...historyClaims]}
						onGridReady={handleAgGridReady}
						animateRows
						rowDragManaged
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true,
							floatingFilterComponentParams: { suppressFilterButton: true }
						}}
						defaultColGroupDef={{ marryChildren: true }}
						rowSelection="single"
						enableCellChangeFlash={true}
						frameworkComponents={{
							PDDTCellRenderer: PDDTCellRenderer,
							checkNumberCellRender: checkNumberCellRender,
							actionCellRender: actionCellRender,
							// customFloatingFilter: CustomFloatingFilter,
							// customFilter: CustomFilter,
							schema: claimsFilterSchema,
							setPayloadSchema: setClaimsFilterSchema,
							functionToBePassed: functionToBePassed
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["actionCellRenderer"]
							});
						}}
					>
						<AgGridColumn field="CLMPRE" headerName="Claim Prefix"></AgGridColumn>
						<AgGridColumn field="CLMNO" headerName="Claim Number"></AgGridColumn>
						<AgGridColumn field="CLMSUF" headerName="Claim Suffix"></AgGridColumn>
						<AgGridColumn
							field="PDDT"
							headerName="Paid Date"
							cellRenderer="PDDTCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="PRVCKNO"
							headerName="Provider Check No"
							cellRenderer="checkNumberCellRender"
						></AgGridColumn>
						<AgGridColumn
							field="EECKNO"
							headerName="Employee Check No"
							cellRenderer="checkNumberCellRender"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="actionCellRender"
							cellRendererParams={{ _currentClaims: currentClaims, _historyClaims: historyClaims }}
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
				{/* <div className="display-flex-end mt-30px pagination">
					<Pagination
						count={pageCount}
						defaultPage={1}
						page={currentPage}
						boundaryCount={2}
						onChange={handlePageChange}
						showFirstButton
						showLastButton
						className="pagination"
					/>
				</div> */}
			</Paper>
		</div>
	);
};

export default withRouter(ClaimList);
